import { TargetedPetitionListRedesign } from './TargetedPetitionListRedesign';

export function TargetedPetitionListWrapper() {
	return (
		<div className="mb-8">
			<TargetedPetitionListRedesign />
		</div>
	);
}
